import { Channel, MyAccountTab, Topic } from "../../../../constants";

import { MessageBrokerUtils } from "../../../../utils";

export const action = () => {
  const funcProps = [
    {
      channel: Channel.PLAYER,
      topic: Topic.CTA_MyAccount_Open,
      headers: { publisher: "unifiedclient" },
      data: { tabId: MyAccountTab.FreeBetsSpectate }
    }
  ];

  MessageBrokerUtils.publish(...funcProps);
};
